import { Entity } from '@/store/shared/entity'
export default class ProductElement extends Entity<number>{
  
        shippingNumber:string;        
      
   
 
        shipmentDate:Date;        
   

        customerName:string;        
    
      
        ownerName:string;  
        
        isHideOk:boolean;
        // 清单
        declarationElementProductDtoList: Array<DeclarationElementProductDto>=new  Array<DeclarationElementProductDto>();

      

}

export class DeclarationElementProductDto{
        id:number;
        itemIndexNumber:number;
        declareCustomsId :number;
        productCode :string; 
        productDescription :string; 
        productElement :string; 
        declareProductFormId :number;
        elementListId :number;
        declarationElementDtoList: Array<DeclarationElementDto>=new Array<DeclarationElementDto>();
        productName: string;
}
export class DeclarationElementDto{
        id:number;
        declarationElementProductId:number;
        elementNo:number;
        element :string; 
        elementValue :string; 

}